import { render } from "./InventoryVe.vue?vue&type=template&id=3fb3b87d&scoped=true"
import script from "./InventoryVe.vue?vue&type=script&lang=js"
export * from "./InventoryVe.vue?vue&type=script&lang=js"

import "./InventoryVe.vue?vue&type=style&index=0&id=3fb3b87d&scoped=true&lang=css"

import exportComponent from "/home/dyam/Documentos/MISTOCK/mi-stock/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3fb3b87d"]])

export default __exports__